import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

const STEP_SIZE = '2.2rem';
const TAIL_SIZE = '8rem';
const BLUE_100 = '#0075be';
const BLUE_10 = '#e5f1f8';

const stepSx = (isActive: boolean) => ({
  position: 'relative',
  width: STEP_SIZE,
  height: STEP_SIZE,
  lineHeight: STEP_SIZE,
  textAlign: 'center',
  borderRadius: '50%',
  margin: '0 auto',
  background: isActive ? BLUE_100 : BLUE_10,
  transition: 'background 0.3s',
  ...(isActive && {
    '& span': { color: 'white' },
    '&::before': {
      position: 'absolute',
      left: '50%',
      top: '-5px',
      transform: 'translateX(-50%)',
      content: '""',
      width: '2.8rem',
      height: '2.8rem',
      border: `1px solid ${BLUE_100}`,
      borderRadius: '50%',
    },
  }),
});

const activeStepHeightSx = (isActive: boolean) => (isActive ? '50%' : '0%');
const tailSx = (isActive: boolean, isStepped: boolean) => ({
  position: 'absolute',
  left: '50%',
  top: isActive ? `calc(${STEP_SIZE} + 0.3rem)` : STEP_SIZE,
  transform: 'translateX(-50%)',
  width: '2px',
  height: '100%',
  padding: `${TAIL_SIZE} 0 6px`,
  display: 'block',
  margin: 0,
  background: BLUE_10,
  '&::before': {
    content: '""',
    position: 'absolute',
    left: '50%',
    top: 0,
    transform: 'translateX(-50%)',
    width: '2px',
    height: isStepped ? 'calc(100% - 1.1rem)' : activeStepHeightSx(isActive),
    display: 'block',
    margin: 0,
    background: BLUE_100,
    ...(isActive && {
      transition: isStepped ? 'height 0.2s' : 'height 0.3s ease',
      transitionDelay: isStepped ? undefined : '0.1s',
    }),
  },
});

const Stepper = ({ number, activeIndex }: { number: number; activeIndex: number }) => (
  <Box component="section" sx={{ margin: 4, justifyContent: 'center', height: '100%' }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {Array.from({ length: number }).map((_, x) => {
        const isActive = x <= activeIndex;
        const isStepped = x < activeIndex;
        const hasTail = x + 1 < number;

        return (
          <Box key={x} sx={{ marginBottom: TAIL_SIZE }}>
            <Box sx={stepSx(isActive)}>
              {hasTail && <Box sx={tailSx(isActive, isStepped)} />}
              <span>{x + 1}</span>
            </Box>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default Stepper;
